module.exports = __webpack_public_path__ + "static/webinars.ab52ba8e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/webinars.gif
// module id = 3226
// module chunks = 213231404188204